import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card, Heading } from "@icg360/design-system";

import { trackEvent, useFlags } from "utils";

import styles from "./featured-offers-ting.module.scss";

export const FeaturedOfferTing = () => {
  const { abTestTingFeaturedImage2 } = useFlags();
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("Featured Offer Card Shown", {
      offerInternalName: "ting-offer",
    });
  }, []);

  const imageFlagMap: Record<string, { url: string; alt: string }> = {
    Control: {
      url: "/assets/images/featured-offer-ting.jpg",
      alt: "Holding newly-opened Ting sensor",
    },
    Variation_A: {
      url: "/assets/images/featured-offer-ting-2.jpg",
      alt: "Woman looking at book sitting next to a plugged in Ting sensor",
    },
  };
  const imageUrl =
    imageFlagMap[(abTestTingFeaturedImage2 ?? "Control") as string].url;
  const imageAlt =
    imageFlagMap[(abTestTingFeaturedImage2 ?? "Control") as string].alt;

  return (
    <Card className={styles.cardDS}>
      <Heading size="md">Property services</Heading>
      <div className={styles.content}>
        <div className={styles.leftCopy}>
          <Heading size="lg" className={styles.heroTextDS}>
            Help prevent electrical fires for free with Ting
          </Heading>
          <Button
            onPress={() =>
              navigate(`/my/property-services/ting-offer`, {
                state: { from: "/my/overview" },
              })
            }
            data-testid="ting-featured-btn"
          >
            Sign up for Ting
          </Button>
        </div>
        <div
          className={styles.imageWrapper}
          role="img"
          aria-label={imageAlt}
          title={imageAlt}
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      </div>
    </Card>
  );
};
